import { ReactNode } from "react";

interface WikiPageProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export const WikiPage = ({ title, description, children }: WikiPageProps) => {
  return (
    <article className="prose prose-invert max-w-none">
      <header className="mb-8 pb-6 border-b border-border">
        <h1 className="text-4xl font-bold text-foreground mb-3">{title}</h1>
        {description && (
          <p className="text-lg text-muted-foreground">{description}</p>
        )}
      </header>
      <div className="text-foreground">
        {children}
      </div>
    </article>
  );
};
